import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import {
    type CropMonitoringNoteFilters,
    createCropMonitoringNote,
    deleteCropMonitoringNote,
    getCropMonitoringNotes,
    updateCropMonitoringNote,
} from '/@/store/crop-monitoring-notes/apiProviders';
import type { CropMonitoringNoteInput } from '/@/types/crop-monitoring-note';
import { invalidate } from '/@/utils/swr';

const LIST_KEY = 'useCropMonitoringNotes';

export const useCropMonitoringNotes = (filters: CropMonitoringNoteFilters = {}) => {
    const key = filters.field ? { key: LIST_KEY, ...filters } : null;
    return useSWR(key, () => getCropMonitoringNotes(filters), {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useMutateCreateCropMonitoringNote = () =>
    useSWRMutation(
        { key: 'createCropMonitoringNote' },
        (_key, { arg }: { arg: CropMonitoringNoteInput }) => createCropMonitoringNote(arg),
        { onSuccess: () => invalidate(LIST_KEY) }
    );

export const useMutateUpdateCropMonitoringNote = () =>
    useSWRMutation(
        { key: 'updateCropMonitoringNote' },
        (_key, { arg }: { arg: { id: number } & CropMonitoringNoteInput }) => {
            const { id, ...data } = arg;
            return updateCropMonitoringNote(id, data);
        },
        {
            onSuccess: () => {
                invalidate(LIST_KEY);
            },
        }
    );

export const useMutateDeleteCropMonitoringNote = () =>
    useSWRMutation(
        { key: 'deleteCropMonitoringNote' },
        (_key, { arg }: { arg: { id: number } }) => deleteCropMonitoringNote(arg.id),
        { onSuccess: () => invalidate(LIST_KEY) }
    );
